// ASYNC TYPES
export const LOADING = 'loading';
export const SUCCESS = 'success';
export const FAIL = 'fail';